import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputNumberField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './TypesofProjectsComponent.module.scss';
import metadata from './TypesofProjectsComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function TypesofProjectsComponent(props) {

    const {
        data: TypesofProjectsVM,
        updateWizardData,
        submissionVM,
        TypesofProjectsPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addTypesofProjects = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            TypesofProjectsVM.value = TypesofProjectsVM.value || []

            const { _xCenter, _dtoName } = TypesofProjectsVM;

            const TypesofProjectsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            TypesofProjectsObjVM.isValidationReq.value = true

            TypesofProjectsVM.pushElement(
                TypesofProjectsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, TypesofProjectsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        (val, changedPath, index) => {

            const comBui4 = _.get(TypesofProjectsVM.value[index], 'comBui4');
            const indBui2 = _.get(TypesofProjectsVM.value[index], 'indBui2');
            const ins5 = _.get(TypesofProjectsVM.value[index], 'ins5');
            const munWatSew3 = _.get(TypesofProjectsVM.value[index], 'munWatSew3');
            const resBui1 = _.get(TypesofProjectsVM.value[index], 'resBui1');
            const oth6 = _.get(TypesofProjectsVM.value[index], 'oth6');

            const total = comBui4 + indBui2 + ins5 + munWatSew3 + resBui1 + oth6;
            _.set(TypesofProjectsVM.value[index], 'totPerOfAllPro7', total);

            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            TypesofProjectsVM.value.splice(index, 1);
            _.set(submissionVM.value, TypesofProjectsPath, TypesofProjectsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, TypesofProjectsPath, TypesofProjectsVM?.value]
    );

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'resBui1') {
                const value = item.resBui1;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.resBui1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={100}
                    />
                );
            }

            if (path === 'indBui2') {
                const value = item.indBui2;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.indBui2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={100}
                    />
                );
            }

            if (path === 'munWatSew3') {
                const value = item.munWatSew3;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.munWatSew3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={100}
                    />
                );
            }

            if (path === 'comBui4') {
                const value = item.comBui4;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.comBui4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={100}
                    />
                );
            }

            if (path === 'ins5') {
                const value = item.ins5;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.ins5 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={100}
                    />
                );
            }

            if (path === 'oth6') {
                const value = item.oth6;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.oth6 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={100}
                    />
                );
            }

            if (path === 'totPerOfAllPro7') {
                const value = item.comBui4 + item.indBui2 + item.ins5 + item.munWatSew3 + item.oth6 + item.resBui1 

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            } 


        }, [handleValueChange, TypesofProjectsVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`TypesofProjectsTable`]: {
            data: TypesofProjectsVM.value,
        }

    }), [TypesofProjectsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addTypesofProjects,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            TypesofProjectsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [TypesofProjectsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={TypesofProjectsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

TypesofProjectsComponent.propTypes = wizardProps;
export default withRouter(TypesofProjectsComponent);
